import { storageRef } from './firebase';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";  // Import these methods from Firebase SDK

export const uploadImagesToServer = async (fileTobeUploaded) => {
    try {
        // Generate a unique file name
        const fileNameAndPath = `10posible/${Math.floor(Math.random() * 10000)}_${fileTobeUploaded.name}`;
        // Create a reference to the storage location
        const fileRef = ref(storageRef, fileNameAndPath);

        // Upload file to Firebase Storage
        const snapshot = await uploadBytes(fileRef, fileTobeUploaded);
        
        console.log('uploadImagesToServer - Uploaded a blob or file!', snapshot);
        console.log('ref - fullPath path', snapshot.ref.fullPath);

        // Get download URL
        const downloadURL = await getDownloadURL(snapshot.ref);

        // Optionally dispatch an action or handle the download URL
        console.log('downloadURL', downloadURL);

        return downloadURL;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
    }
}